<template>
  <div class="api-lookup-form-data h-100">
    <Loading
      :active.sync="isLoading"
      :is-full-page="false"
      :color="loaderColor"
      loader="dots"
      :background-color="loaderBackgroundColor"
    />
    <div
      v-for="(row, index) in formData"
      :key="`form-data-row-${index}`"
      class="custom-form-data-row pl-0"
    >
      <VasionInput
        v-model="row.FormDataKey"
        title="Key"
        name="api-lookup-form-data-key"
        placeholder="Key..."
        inputType="top-white"
        required
        @input="emitSectionIsDirty"
      />
      <VasionDropList
        v-show="formType === '2'"
        v-model="row.FormDataType"
        v-slot="slotItem"
        :dataArray="lists.types"
        :required="true"
        :showIfEmpty="true"
        :showSearchField="false"
        :returnValueOnly="true"
        @input="emitSectionIsDirty"
        displayName="label"
        title="Type"
        type="plain-list"
        valueName="value"
        width="100"
      >
        {{ slotItem.item.label }}
      </VasionDropList>
      <div v-show="formType === '6'"></div>
      <VasionInput
        v-if="row.FormDataType === 1"
        :id="`formdatavalue-${index}`"
        v-model="row.FormValue"
        data-paste-target="true"
        title="Value"
        name="api-lookup-form-data-value"
        placeholder="Value..."
        inputType="top-white"
        required
        @input="emitSectionIsDirty"
      />
      <div v-else></div>
      <VasionButton
        name="delete-form-data-row"
        icon="VasionDeleteIcon"
        title="Delete form data row"
        class="delete-form-data-btn"
        @vasionButtonClicked="removeFormDataRow(index)"
      />
    </div>
    <VasionButton
      class="ml-0"
      classProp="secondary"
      @vasionButtonClicked="onAddNewRowClick"
    >
      ADD NEW ROW
    </VasionButton>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import { loaderBackgroundColor, loaderColor } from '@/assets/js/styleConfig'

export default {
  name: 'ApiLookupFormData',
  components: {
    Loading,
  },
  props: {
    configurationData: {
      type: Object,
      required: true,
    },
    formType: {
      type: String,
      required: true,
    }
  },
  data() {
    return {
      editableData: this.configurationData,
      formData: [{ FormDataKey: '', FormDataType: 1, FormValue: '' }],
      isLoading: false,
      lists: {
        types: [
          { label: 'Text', value: 1 },
          { label: 'File', value: 2 },
        ],
      },
      loaderBackgroundColor: loaderBackgroundColor,
      loaderColor: loaderColor,
      settingData: false,
    }
  },
  watch: {
    configurationData: {
      immediate: true,
      handler(val) {
        if (val && val?.ApiRequestBodyFormData) {
          this.editableData = val
          this.setFormDataFields(val)
        }
      },
    },
  },
  computed: {},
  async created() {
    this.isLoading = true

    if (this.editableData) this.setFormDataFields(this.editableData)

    this.isLoading = false
  },
  methods: {
    emitSectionIsDirty() {
      this.$emit('markAsDirty', this.formData)
    },
    onAddNewRowClick() {
      this.formData.push({ FormDataKey: '', FormDataType: 1, FormValue: '' })
    },
    removeFormDataRow(index) {
      this.formData.splice(index, 1)
    },
    setFormDataFields(data) {
      if (this.settingData) return

      this.settingData = true

      if (data.ApiRequestBodyFormData)
        this.formData = data.ApiRequestBodyFormData
      this.settingData = false
    },
    setReactiveValue(formdata, value) {
      const indexStr = formdata.match(/-(\d+)$/)
      const index = parseInt(indexStr[1])
      this.formData[index].FormValue = value
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/variables.scss';
@import '@/assets/css/light-theme-system-palette.scss';

::v-deep .ml-0 button {
  margin-left: 0;
}
div.custom-form-data-row {
  padding: 6px;
  display: grid;
  grid-template-columns: minmax(320px, 1fr) 100px minmax(320px, 1fr) 50px;
  grid-gap: 8px;
  margin-top: 8px;
  margin-bottom: 8px;
}
.delete-form-data-btn {
  display: flex;
  align-items: end;
  padding-bottom: 4px;
}
</style>
